import React, { useState } from "react";

import { motion, MotionValue } from "framer-motion";

const MotionWrap = (Component, classNames) =>
  function HOC({ overlay, setOverlay, setEmailInvalid }) {
    console.log(overlay);
    const [backdrop, setBackdrop] = useState(false);
    return (
      <motion.div
        whileInView={{ y: [100, 50, 0], opacity: [0, 0, 1] }}
        transition={{ duration: 0.5 }}
        className={`${classNames} app__flex`}
      >
        <Component
          overlay={overlay}
          setOverlay={setOverlay}
          setEmailInvalid={setEmailInvalid}
        />
      </motion.div>
    );
  };

export default MotionWrap;
